import { render, staticRenderFns } from "./sign-up-purchase-detail.html?vue&type=template&id=443f3a66&scoped=true&external"
import script from "./sign-up-purchase-detail.js?vue&type=script&lang=js&external"
export * from "./sign-up-purchase-detail.js?vue&type=script&lang=js&external"
import style0 from "./sign-up-purchase-detail.scss?vue&type=style&index=0&id=443f3a66&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443f3a66",
  null
  
)

export default component.exports